import { PostAdd, Refresh } from '@mui/icons-material'
import _ from 'lodash'
import React, { Children, isValidElement } from 'react'
import parse from 'html-react-parser'
import { Spin } from 'antd'
import { NOTE_TYPE } from '../../../../constant'
import { showWarningMessage } from '../../../../utils/showMessage'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';


const BotResponseItem = ({
  chatData,
  chatItem,
  text = '',
  isLastIndex = true,
  onAddNote = () => { },
  onRegenerate = () => { },
  isLoading,
  openReferenceRegulationModal = () => { }
}) => {
  const { t } = useTranslation()



  return (
    <div className="flex gap-2 w-full" id={chatItem?.id}>
      <div className="flex justify-center items-start w-10">
        <div className="rounded-full overflow-hidden h-6 w-6 bg-[#0049EE]"></div>
      </div>
      <div className="flex w-full h-full flex-col items-start justify-start">
        <span className="text-base font-bold">Legal AI</span>
        <div className="w-full h-full bot-response">
          {isLoading && isLastIndex ? (
            <div className="w-full h-full flex justify-center items-center">
              <Spin />
            </div>
          ) : (

            <ReactMarkdown
              remarkPlugins={[remarkMath]}
              rehypePlugins={[rehypeKatex]}
              components={{
                ol: ({ node, ...props }) => (
                  <ul className="list-disc list-inside" {...props} />
                ),
                li: ({ node, children, ...props }) => (
                  <li {...props}>
                    {Children.toArray(children).map((child, index) => {
                      if (isValidElement(child) && child.type === 'p') {
                        return <React.Fragment key={index}>{child.props.children}</React.Fragment>;
                      }
                      return child;
                    })}
                  </li>
                )
              }}
            >
              {text}
            </ReactMarkdown>

          )}
          {chatItem?.articles?.length > 0 && (
            <div className="mt-3">
              Articoli collegati:
              {chatItem?.articles?.map((article, index) => {
                return (
                  <span
                    onClick={() => {

                      if (article.indexOf('c.p.p.') > -1) {
                        openReferenceRegulationModal(article, 'CRIMINAL_P')
                      } else if (article.indexOf('c.c.') > -1) {
                        openReferenceRegulationModal(article, 'CIVIL')
                      } else if (article.indexOf('c.p.c.') > -1) {
                        openReferenceRegulationModal(article, 'CIVIL_P')
                      } else if (article.indexOf('c.p.') > -1) {
                        openReferenceRegulationModal(article, 'CRIMINAL')
                      } else {
                        showWarningMessage(t('Impossibile ricondurre l\'articolo a un codice'))
                      }
                    }}
                    key={`article-${index}`}
                    className="text-[#0049EE] cursor-pointer hover:underline">
                    {` [${article}] `}
                  </span>
                )
              })}
            </div>
          )}
        </div>
        <div className="flex gap-2 items-center pt-2 text-[#919191] ">
          <div
            onClick={() => {
              onAddNote({
                type: NOTE_TYPE.CHAT,
                text: text.replace(/(<([^>]+)>)/gi, ''),
                chat: chatData
              })
            }}>
            <PostAdd className="cursor-pointer hover:text-[#5c5b5b]" />
          </div>

          <div
            onClick={() => {
              _.throttle(() => {
                return onRegenerate(chatItem.id)
              }, 1000)()
            }}>
            <Refresh className="cursor-pointer hover:text-[#5c5b5b]" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BotResponseItem
